var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServices2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "services2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.644,
    height: 44.246,
    viewBox: "0 0 50.644 44.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M44.012,32.34H6.631A6.639,6.639,0,0,0,0,38.971V60.494a6.639,6.639,0,0,0,6.631,6.631H26.446v5.805A3.66,3.66,0,0,0,30.1,76.586H41.124a3.659,3.659,0,0,0,3.655-3.655V67.078a6.639,6.639,0,0,0,5.865-6.583V38.971A6.639,6.639,0,0,0,44.012,32.34ZM42.844,72.931a1.721,1.721,0,0,1-1.72,1.72H30.1a1.722,1.722,0,0,1-1.721-1.72V62.607H42.844V72.931ZM31.671,60.672V57a3.949,3.949,0,0,1,7.882,0v3.671Zm17.038-.177a4.693,4.693,0,0,1-3.929,4.618V61.64a.967.967,0,0,0-.967-.967H41.489V57a5.882,5.882,0,0,0-11.754,0v3.671H27.414a.967.967,0,0,0-.967.967v3.551H6.631a4.7,4.7,0,0,1-4.7-4.7V47.444H48.709Zm0-14.986H1.935v-3.3H48.709v3.3Zm0-5.238H1.935v-1.3a4.7,4.7,0,0,1,4.7-4.7H44.013a4.7,4.7,0,0,1,4.7,4.7Z",
    transform: "translate(0 -32.34)",
    fill: "#1d2547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M59.662,309.134H75.1a.967.967,0,1,0,0-1.935H59.662a.967.967,0,1,0,0,1.935Z",
    transform: "translate(-52.889 -280.012)",
    fill: "#1d2547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M330.669,357.462v2.158a.967.967,0,0,0,1.935,0v-2.158a3.117,3.117,0,1,0-1.935,0Zm.967-4.132a1.183,1.183,0,1,1-1.182,1.183A1.185,1.185,0,0,1,331.636,353.33Z",
    transform: "translate(-296.024 -319.835)",
    fill: "#1d2547"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices2);
export default __webpack_public_path__ + "static/media/services2.39c80dc2bee8dc584b2625b8482e8c96.svg";
export { ForwardRef as ReactComponent };